import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 999;

  .tooltip {
    color: var(--white);
    font-family: DM Sans;
    font-size: 0.9rem !important;
    width: auto;
    opacity: 1 !important;
    margin-left: -1.25rem !important;
    z-index: 999;
  }
`;
